import { Injectable } from '@angular/core';
import { DeviceModel } from '../../models/device.model';
import { LocalStorageService } from './local-storage.service';

@Injectable({
    providedIn: 'root',
})
export class DeviceService {
    private readonly DEVICE_KEY = 'p2p_device';

    constructor(private localStorageService: LocalStorageService) {}

    clear(): void {
        this.localStorageService.removeItem(this.DEVICE_KEY);
    }

    getDeviceInfo(): DeviceModel {
        const deviceInfo = this.localStorageService.getItem(this.DEVICE_KEY);
        if (!deviceInfo) {
            const newDeviceInfo = new DeviceModel();
            this.setDeviceInfo(newDeviceInfo);
            return newDeviceInfo;
        }

        const currentDeviceInfo = JSON.parse(deviceInfo) as DeviceModel;
        return currentDeviceInfo;
    }

    private setDeviceInfo(deviceInfo: DeviceModel): void {
        const stringBaseDeviceInfo = JSON.stringify(deviceInfo);
        this.localStorageService.setItem(this.DEVICE_KEY, stringBaseDeviceInfo);
    }
}
